import React , { Component } from "react";
import {Modal} from "react-bootstrap";
import {ActionButtonsEnum} from "./Enum/ActionButtonsEnum";


class BottomSheetAction extends Component {

    constructor(props) {
        super(props);
    }
    componentDidMount() {
    }

    handleClick = (type , data) => e => {
        this.props.action(type , data)
    }

    render() {
        return (
            <Modal className='bottom-sheet fade in' show={this.props.show} onHide={this.props.onHide}>
                <Modal.Body style={{maxHeight : '75vh' , overflowY : 'auto'}}>
                    <div className='d-flex justify-content-center pt-10 pb-10'>
                        <div className='bottom-sheet-close-line btn p-0 ' />
                    </div>
                    <div className='row align-items-center mt-24'>
                        {
                            this.props.buttons.includes(ActionButtonsEnum.DELETE)
                                ? <div className={'col-auto'}>
                                    <div onClick={this.handleClick(ActionButtonsEnum.DELETE , this.props.data)}>
                                        <div className='icon-cnt-round-44 bg-light-red'>
                                            <div className='img-cnt-24'>
                                                <img src={"/assets/images/vectors/trash_bin_white.svg"} />
                                            </div>
                                        </div>
                                        <div className='mobile-body-2-strong text-center cl-black mt-8'>
                                            حذف
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }
                        {
                            this.props.buttons.includes(ActionButtonsEnum.EDIT)
                                ? <div className='col-auto'>
                                    <div onClick={this.handleClick(ActionButtonsEnum.EDIT , this.props.data)}>
                                        <div className='icon-cnt-round-44 bg-light-blue'>
                                            <div className='img-cnt-24'>
                                                <img src={"/assets/images/vectors/edit_white.svg"} />
                                            </div>
                                        </div>
                                        <div className='mobile-body-2-strong text-center cl-black mt-8'>
                                            ویرایش
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }
                        {
                            this.props.buttons.includes(ActionButtonsEnum.DEFAULT)
                                ? <div className='col-auto'>
                                    <div onClick={this.handleClick(ActionButtonsEnum.DEFAULT , this.props.data)}>
                                        <div className='icon-cnt-round-44 bg-green'>
                                            <div className='img-cnt-24'>
                                                <img src={"/assets/images/vectors/gallery_white.svg"} />
                                            </div>
                                        </div>
                                        <div className='mobile-body-2-strong text-center cl-black mt-8'>
                                            پیشفرض
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }
                        {
                            this.props.buttons.includes(ActionButtonsEnum.STATUS)
                                ? <div className='col-auto'>
                                    <div onClick={this.handleClick(ActionButtonsEnum.STATUS , this.props.data)}>
                                        <div className='icon-cnt-round-44 bg-yellow'>
                                            <div className='img-cnt-24'>
                                                <img src={"/assets/images/vectors/gallery_white.svg"} />
                                            </div>
                                        </div>
                                        <div className='mobile-body-2-strong text-center cl-black mt-8'>
                                            فعالسازی
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default BottomSheetAction